import React from 'react';
import "../Styles/CoursePage.css"; // Ensure you have the correct path to your CSS file
import CourseImage from '../Assets/BackgroundImg2.png';
import Footer from './Footer'; // Adjust the import path as necessary
import courseImage1 from '../Assets/HealthCare.png'; // Placeholder image, replace with actual image path
import courseImage2 from '../Assets/Soft Skill.png'; // Placeholder image, replace with actual image path
import courseImage3 from '../Assets/Language Training.png'; // Placeholder image, replace with actual image
import courseImage4 from '../Assets/MBA copy.png'; // Placeholder image, replace with actual image path
function FacultyPage() {
  return (
    <div className='coursePage-container'>
      {/* Banner Section */}
      <div className="home-banner">
        <img src={CourseImage} alt="Course Banner" className="home-img" />
      </div>
      <section className="coursePage-section">
        <div className="coursePage-card">
          <h2>Our Courses </h2>
          <div className='courseCard-flex'>
          <div className='coursePage-subcontainer'>
            <div className='coursePage-subImage-container'>
            <img src={courseImage1} alt='course details' className='coursePage-subImage' />
            </div>
             <div className='coursePage-content'>
                <h4>Us Medical Health and care</h4>
                <p> <ul>
           <li>Beginner’s Medical Files (Audio & Transcripts)</li>
           <li>Nuances of Medical Reports</li>
           <li>Medical Terminologies</li>
           <li>Medical English Grammar</li>
           <li>Speed Typing Skills</li>
           </ul></p>
             </div>
            </div>
            <div className='coursePage-subcontainer'>
            <div className='coursePage-subImage-container'>
            <img src={courseImage2} alt='course details' className='coursePage-subImage' />
            </div>
             <div className='coursePage-content'>
                <h4>Language Training</h4>
                <p> 
            <ul>
            <li>Listening Speaking Writing Reading</li>
            <li>Augusta Batch 1 (BO) By Fluency Center</li>
            <li>Augusta Batch 2 (BOC) By Fluency Center</li>
            <li>(Second Language Teacher Education) By Fluency Center</li>
            </ul>
            </p>
             </div>
            </div>
            <div className='coursePage-subcontainer'>
            <div className='coursePage-subImage-container'>
            <img src={courseImage3} alt='course details' className='coursePage-subImage' />
            </div>
             <div className='coursePage-content'>
                <h4>Soft Skills</h4>
                <p>
           <ul>
             <li>Hash Agile (Career Development Program) By Fluency Center</li>
             <li>Executive English Training: ABT</li>
             <li>Executive Advanced</li>
             <li>Executive Intermediate</li>
             <li>Executive Assessment</li>
           </ul>
                </p>
             </div>
            </div>
            <div className='coursePage-subcontainer'>
            <div className='coursePage-subImage-container'>
            <img src={courseImage4} alt='course details' className='coursePage-subImage' />
            </div>
             <div className='coursePage-content'>
                <h4>Management MBA</h4>
                <p>
            <ul>
              <li>Operation Management</li>
              <li>Corporate Communication</li>
              <li>Research Methods for Management</li>
              <li>Quantitative Techniques for Management</li>
              <li>Human Resource Management</li>
              <li>Marketing Management</li>
            </ul>
                </p>
             </div>
            </div>
           </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
}

export default FacultyPage;